/**
 * This file was automatically generated and should not be edited.
 * Source: tokens.json from Figma variables (/sync-design-tokens) via scripts/generateTokensFromFigma.mjs
 */
export const BORDER_BORDER_CONTRAST = 'var(--border-border-contrast)';
export const BORDER_BORDER_DARK = 'var(--border-border-dark)';
export const BORDER_BORDER_DEFAULT = 'var(--border-border-default)';
export const BORDER_BORDER_DESTRUCTIVE = 'var(--border-border-destructive)';
export const BORDER_BORDER_DISABLED = 'var(--border-border-disabled)';
export const BORDER_BORDER_EMPHASIS = 'var(--border-border-emphasis)';
export const BORDER_BORDER_FOCUS = 'var(--border-border-focus)';
export const BORDER_BORDER_MODERATE = 'var(--border-border-moderate)';
export const BORDER_BORDER_MUTED = 'var(--border-border-muted)';
export const BORDER_BORDER_SUBTLE = 'var(--border-border-subtle)';
export const BORDER_BORDER_SUCCESS = 'var(--border-border-success)';
export const BORDER_BORDER_WARNING = 'var(--border-border-warning)';
export const CHART_SERIES_SERIES_COMPARISON = 'var(--chart-series-series-comparison)';
export const CHART_SERIES_SERIES_CURRENT = 'var(--chart-series-series-current)';
export const CHART_SERIES_SERIES_SECONDARY = 'var(--chart-series-series-secondary)';
export const ICON_ICON_BRAND = 'var(--icon-icon-brand)';
export const ICON_ICON_DESTRUCTIVE = 'var(--icon-icon-destructive)';
export const ICON_ICON_DISABLED = 'var(--icon-icon-disabled)';
export const ICON_ICON_INFORMATIVE = 'var(--icon-icon-informative)';
export const ICON_ICON_PLACEHOLDER = 'var(--icon-icon-placeholder)';
export const ICON_ICON_PREMIUM = 'var(--icon-icon-premium)';
export const ICON_ICON_PRIMARY = 'var(--icon-icon-primary)';
export const ICON_ICON_REVERSED = 'var(--icon-icon-reversed)';
export const ICON_ICON_SECONDARY = 'var(--icon-icon-secondary)';
export const ICON_ICON_SUCCESS = 'var(--icon-icon-success)';
export const ICON_ICON_TERTIARY = 'var(--icon-icon-tertiary)';
export const ICON_ICON_WARNING = 'var(--icon-icon-warning)';
export const INPUT_INPUT_BG_ACTIVE = 'var(--input-input-bg-active)';
export const INPUT_INPUT_BG_DEFAULT = 'var(--input-input-bg-default)';
export const INPUT_INPUT_BG_DISABLED = 'var(--input-input-bg-disabled)';
export const INPUT_INPUT_BG_ERROR = 'var(--input-input-bg-error)';
export const INPUT_INPUT_BG_HOVER = 'var(--input-input-bg-hover)';
export const INPUT_INPUT_BORDER_ACTIVE = 'var(--input-input-border-active)';
export const INPUT_INPUT_BORDER_ACTIVE_EFFECT = 'var(--input-input-border-active-effect)';
export const INPUT_INPUT_BORDER_DEFAULT = 'var(--input-input-border-default)';
export const INPUT_INPUT_BORDER_ERROR = 'var(--input-input-border-error)';
export const INPUT_INPUT_BORDER_HOVER = 'var(--input-input-border-hover)';
export const SURFACE_BACKGROUNDS_BG_DISABLED = 'var(--surface-backgrounds-bg-disabled)';
export const SURFACE_BACKGROUNDS_BG_MODERATE = 'var(--surface-backgrounds-bg-moderate)';
export const SURFACE_BACKGROUNDS_BG_MUTED = 'var(--surface-backgrounds-bg-muted)';
export const SURFACE_BACKGROUNDS_BG_PRIMARY = 'var(--surface-backgrounds-bg-primary)';
export const SURFACE_BACKGROUNDS_BG_REVERSE = 'var(--surface-backgrounds-bg-reverse)';
export const SURFACE_BACKGROUNDS_BG_SECONDARY = 'var(--surface-backgrounds-bg-secondary)';
export const SURFACE_BACKGROUNDS_BG_TERTIARY = 'var(--surface-backgrounds-bg-tertiary)';
export const SURFACE_BACKGROUNDS_BLANKET = 'var(--surface-backgrounds-blanket)';
export const SURFACE_BRAND_BRAND_BOLD = 'var(--surface-brand-brand-bold)';
export const SURFACE_BRAND_BRAND_BOLD_HOVER = 'var(--surface-brand-brand-bold-hover)';
export const SURFACE_BRAND_BRAND_BOLD_PRESSED = 'var(--surface-brand-brand-bold-pressed)';
export const SURFACE_BRAND_BRAND_SUBTLE = 'var(--surface-brand-brand-subtle)';
export const SURFACE_BRAND_BRAND_SUBTLE_HOVER = 'var(--surface-brand-brand-subtle-hover)';
export const SURFACE_BRAND_BRAND_SUBTLE_PRESSED = 'var(--surface-brand-brand-subtle-pressed)';
export const SURFACE_DESTRUCTIVE_DESTRUCTIVE_BOLD = 'var(--surface-destructive-destructive-bold)';
export const SURFACE_DESTRUCTIVE_DESTRUCTIVE_BOLD_HOVER = 'var(--surface-destructive-destructive-bold-hover)';
export const SURFACE_DESTRUCTIVE_DESTRUCTIVE_SUBTLE = 'var(--surface-destructive-destructive-subtle)';
export const SURFACE_DESTRUCTIVE_DESTRUCTIVE_SUBTLE_HOVER = 'var(--surface-destructive-destructive-subtle-hover)';
export const SURFACE_DESTRUCTIVE_DESTRUCTIVE_SUBTLE_PRESSED = 'var(--surface-destructive-destructive-subtle-pressed)';
export const SURFACE_DESTRUCTIVE_URGENT_BOLD_PRESSED = 'var(--surface-destructive-urgent-bold-pressed)';
export const SURFACE_HIGHLIGHT_PREMIUM_HIGHLIGHT_BOLD = 'var(--surface-highlight-premium-highlight-bold)';
export const SURFACE_HIGHLIGHT_PREMIUM_HIGHLIGHT_BOLD_HOVER = 'var(--surface-highlight-premium-highlight-bold-hover)';
export const SURFACE_HIGHLIGHT_PREMIUM_HIGHLIGHT_BOLD_PRESSED =
  'var(--surface-highlight-premium-highlight-bold-pressed)';
export const SURFACE_HIGHLIGHT_PREMIUM_HIGHLIGHT_SUBTLE = 'var(--surface-highlight-premium-highlight-subtle)';
export const SURFACE_HIGHLIGHT_PREMIUM_HIGHLIGHT_SUBTLE_HOVER =
  'var(--surface-highlight-premium-highlight-subtle-hover)';
export const SURFACE_HIGHLIGHT_PREMIUM_HIGHLIGHT_SUBTLE_PRESSED =
  'var(--surface-highlight-premium-highlight-subtle-pressed)';
export const SURFACE_NEUTRAL_NEUTRAL_BOLD = 'var(--surface-neutral-neutral-bold)';
export const SURFACE_NEUTRAL_NEUTRAL_BOLD_HOVER = 'var(--surface-neutral-neutral-bold-hover)';
export const SURFACE_NEUTRAL_NEUTRAL_BOLD_PRESSED = 'var(--surface-neutral-neutral-bold-pressed)';
export const SURFACE_NEUTRAL_NEUTRAL_SUBTLE = 'var(--surface-neutral-neutral-subtle)';
export const SURFACE_NEUTRAL_NEUTRAL_SUBTLE_HOVER = 'var(--surface-neutral-neutral-subtle-hover)';
export const SURFACE_NEUTRAL_NEUTRAL_SUBTLE_PRESSED = 'var(--surface-neutral-neutral-subtle-pressed)';
export const SURFACE_POSITIVE_POSITIVE_BOLD = 'var(--surface-positive-positive-bold)';
export const SURFACE_POSITIVE_POSITIVE_BOLD_HOVER = 'var(--surface-positive-positive-bold-hover)';
export const SURFACE_POSITIVE_POSITIVE_BOLD_PRESSED = 'var(--surface-positive-positive-bold-pressed)';
export const SURFACE_POSITIVE_POSITIVE_SUBTLE = 'var(--surface-positive-positive-subtle)';
export const SURFACE_POSITIVE_POSITIVE_SUBTLE_HOVER = 'var(--surface-positive-positive-subtle-hover)';
export const SURFACE_POSITIVE_POSITIVE_SUBTLE_PRESSED = 'var(--surface-positive-positive-subtle-pressed)';
export const SURFACE_WARNING_WARNING_BOLD = 'var(--surface-warning-warning-bold)';
export const SURFACE_WARNING_WARNING_BOLD_HOVER = 'var(--surface-warning-warning-bold-hover)';
export const SURFACE_WARNING_WARNING_BOLD_PRESSED = 'var(--surface-warning-warning-bold-pressed)';
export const SURFACE_WARNING_WARNING_SUBTLE = 'var(--surface-warning-warning-subtle)';
export const SURFACE_WARNING_WARNING_SUBTLE_HOVER = 'var(--surface-warning-warning-subtle-hover)';
export const SURFACE_WARNING_WARNING_SUBTLE_PRESSED = 'var(--surface-warning-warning-subtle-pressed)';
export const TEXT_TEXT_BRAND = 'var(--text-text-brand)';
export const TEXT_TEXT_DESTRUCTIVE = 'var(--text-text-destructive)';
export const TEXT_TEXT_DISABLED = 'var(--text-text-disabled)';
export const TEXT_TEXT_INFORMATIVE = 'var(--text-text-informative)';
export const TEXT_TEXT_PREMIUM = 'var(--text-text-premium)';
export const TEXT_TEXT_PRIMARY = 'var(--text-text-primary)';
export const TEXT_TEXT_REVERSED = 'var(--text-text-reversed)';
export const TEXT_TEXT_SECONDARY = 'var(--text-text-secondary)';
export const TEXT_TEXT_SUCCESS = 'var(--text-text-success)';
export const TEXT_TEXT_TERTIARY = 'var(--text-text-tertiary)';
export const TEXT_TEXT_WARNING = 'var(--text-text-warning)';
